import { Alert, Typography } from '@mui/material';
import { DateTime } from 'luxon';

const TimestampSummaryIndicator = ({ globalTimeRange, timestampSummary }) => {
  // Parse timestamp boundaries using Luxon
  const maxEarliest = DateTime.fromISO(
    timestampSummary?.maxEarliestDataTimestamp || '',
  );
  const minLatest = DateTime.fromISO(
    timestampSummary?.minLatestDataTimestamp || '',
  );
  const currentStart = DateTime.fromMillis(globalTimeRange.start);
  const currentEnd = DateTime.fromMillis(globalTimeRange.end);

  const syncedStartFormatted = maxEarliest
    .setLocale('da')
    .plus({ days: 1 })
    .toFormat('d. MMMM yyyy');
  const syncedEndFormatted = minLatest
    .setLocale('da')
    .minus({ days: 1 })
    .toFormat('d. MMMM yyyy');

  // Check if current time range is outside bounds
  const isOutOfBounds = currentStart < maxEarliest || currentEnd > minLatest;

  const isCompletelyOutside =
    currentEnd < maxEarliest || currentStart > minLatest;

  const isInverted = maxEarliest > minLatest;
  const isStartTooEarly = currentStart < maxEarliest;
  const isEndTooLate = currentEnd > minLatest;

  // Only render button if there's an issue
  if (!isOutOfBounds && !isInverted) return null;

  return (
    <Alert
      variant="outlined"
      severity="warning"
      sx={{ p: 2, m: 2, maxWidth: 750, backgroundColor: 'background.paper' }}
    >
      {/* Synkroniseringsfejl for {timestampSummarySetBy} */}
      {/* <EventBusyRoundedIcon color="warning" /> */}
      <Typography variant="body2" gutterBottom>
        Der er en uoverensstemmelse mellem de valgte data og den valgte
        tidsperiode. Dette kan skyldes en ændring i datagrundlaget eller
        manglende kildeopdatering. <br /> EnergyXplorer anvender eget
        måleudstyr, sammen med Datahub data som ikke altid er synkroniseret.
      </Typography>
      {isInverted ? (
        <Typography variant="body2" sx={{ mt: 1 }}>
          Der er en fejl i datagrundlaget — startdatoen ({syncedStartFormatted})
          er efter slutdatoen ({syncedEndFormatted}). <br />
          Dette tyder på en forkert konfiguration eller manglende data. Kontakt
          venligst support.
        </Typography>
      ) : isCompletelyOutside ? (
        <Typography variant="body2" sx={{ mt: 1 }}>
          Den valgte periode ligger <strong>helt uden for</strong> det
          tilgængelige datasæt.
          <br />
          Den tilgængelige periode er mellem{' '}
          <strong>{syncedStartFormatted}</strong> og{' '}
          <strong>{syncedEndFormatted}</strong>.
        </Typography>
      ) : (
        <>
          {isStartTooEarly && isEndTooLate && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Både <strong>startdatoen</strong> og <strong>slutdatoen</strong>{' '}
              ligger uden for det synkroniserede datasæt.
              <br />
              Tilladt periode er mellem <strong>
                {syncedStartFormatted}
              </strong>{' '}
              og <strong>{syncedEndFormatted}</strong>.
            </Typography>
          )}
          {isStartTooEarly && !isEndTooLate && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Startdatoen</strong> ligger før det synkroniserede
              datasæt.
              <br />
              Tidligste tilladte startdato er{' '}
              <strong>{syncedStartFormatted}</strong>.
            </Typography>
          )}
          {!isStartTooEarly && isEndTooLate && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Slutdatoen</strong> ligger efter det synkroniserede
              datasæt. Seneste tilladte slutdato er{' '}
              <strong>{syncedEndFormatted}</strong>.
            </Typography>
          )}
        </>
      )}
    </Alert>
  );
};

export default TimestampSummaryIndicator;
